import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    width: '70%',
    height: 65,
    padding: "10px 25px",
  },
  downloadExcelBtn: {
    background: `linear-gradient(#00A19A,#4582E8,#2F7DFF)`,
    color: theme.palette.common.white,
    borderRadius: 8,
    borderColor: theme.palette.primary.primaryBlue,
    "&:hover": {
      borderColor: theme.palette.primary.primaryBlue,
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
  },
  downloadPdfBtn: {
    background: `linear-gradient(#00A19A,#4582E8,#2F7DFF)`,
    color: theme.palette.common.white,
    borderRadius: 8,
    "&:hover": {
      borderColor: theme.palette.primary.green,
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
  },
}));

export default useStyles;
